import React from 'react'
import { useTranslation } from 'react-i18next'

import { BRAND_KEYWORDS } from '../../fields'

import MultipleOptionsField from '../../../../../ReusableFormFields/MultipleOptionsField'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

function BrandKeywordsSection({ formik }) {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Brand Keywords')}</h3>
      <p>{t('Please enter the brand keyword or keywords that determine which social posts to display.')}</p>
      <MultipleOptionsField fieldLabel="keyword" listFieldName={BRAND_KEYWORDS} formik={formik} />
    </section>
  )
}

export default BrandKeywordsSection
